import {applyFilters} from './filters';
import {APIActionStatus, Form, formsStore} from '../../../stores/Form';
import {PAGE_LIMIT} from '../consts/pagination';
import {callLinkedActions, handleScreenMessage} from './screen';
import {prefetchSubformData} from './form';

export const requestPaginationData = async (
    currentForm: Form,
    top: number,
    offset: number,
    focusRowIndex?: number,
    ignoreSubform?: boolean
) => {
    return await applyFilters(
        {form: currentForm, top, skip: offset, focusRowIndex},
        false,
        ignoreSubform
    );
};

export const fetchFirstPage = async (form: Form, focusRowIndex?: number) => {
    return requestPaginationData(form, PAGE_LIMIT, 0, focusRowIndex, true);
};

export const fetchLastPage = async (form: Form, focusRowIndex?: number) => {
    const offset = Math.floor(form.allRecordsCount / PAGE_LIMIT) * PAGE_LIMIT;
    if (offset) {
        return await requestPaginationData(form, PAGE_LIMIT, offset, focusRowIndex, true);
    }
    return form;
};

export const recordViewPaginationGoTo = async (
    form: Form,
    newFocusRowIndex: number,
    fetchData: boolean,
    offset: number
) => {
    return callLinkedActions(
        formsStore.currentScreen.checkAndSave,
        async () => {
            if (fetchData) {
                const res = await requestPaginationData(form, PAGE_LIMIT, offset, newFocusRowIndex);
                return handleScreenMessage(res, {});
            }
            return formsStore.currentScreen.onFieldFocusChange(
                {
                    newCellIndex: form.currentColumn.index,
                    newRowIndex: newFocusRowIndex,
                    level: form.level
                },
                (newCellIndex, nextRowIndex) => form.setCurrentRow(nextRowIndex)
            );
        },
        async () => {
            const activeSubFormName = form.activeSubForm?.ename || form.subFormsList?.[0].Ename;
            if (!activeSubFormName || form.currentRecord.isNew) return APIActionStatus.passed;
            return prefetchSubformData(form, newFocusRowIndex);
        }
    );
};
